export const getTimeFromString = stringTime => {
  const hourValue = parseInt(stringTime.slice(0, -2), 10)
  const isBeforeNoon =
    hourValue === 12 ? stringTime.slice(-2) !== 'am' : stringTime.slice(-2) === 'am'

  return isBeforeNoon ? hourValue : hourValue + 12
}
